import { defaultSelectMenuProps } from "./formControls";
import {
	captchaDisplayBackground,
	captchaDisplayBorder,
	captchaDisplayBorderWidth,
	captchaDisplayRadius,
} from "./tokens";

/** Auth form layout + typography — aligned with employer portal (admin brand colors). */

export const authSelectMenuPaperClassName = "auth-select-menu";

export const authSelectMenuProps = {
	...defaultSelectMenuProps,
	PaperProps: {
		...defaultSelectMenuProps.PaperProps,
		className: authSelectMenuPaperClassName,
	},
};

export const authPageHeadingClassName =
	"auth-page-heading font-['Poppins'] text-4xl font-semibold tracking-tight text-auth-heading short:text-[1.625rem] short:leading-tight";

export const authCardHeadingSubtextClassName =
	"auth-card-subtext mt-[8px] text-[14px] text-[#494949] short:text-[14px]";

export const authFieldLabelClassName = "font-semibold text-foreground";

export const authFormStackClassName = "space-y-3 short:space-y-1.5";

export const authFormStackLooseClassName = "space-y-4 short:space-y-2";

export const authFormGridGapClassName = "gap-3 short:gap-2";

export const authFormSectionInsetClassName = "px-3";

export const authSubmitButtonMarginClassName = "auth-submit-button !mt-[20px] !mb-4";

/** Submit — employer sizing with admin primary tokens via Tailwind theme. */
export const authSubmitButtonClassName =
	`${authSubmitButtonMarginClassName} min-h-[44px] h-[44px] !py-0 w-full !rounded-[10px] !font-['Poppins'] !text-base !font-semibold !leading-normal !tracking-normal !text-primary-foreground shadow-sm hover:shadow-md !border-0 !bg-primary hover:!bg-primary-hover short:min-h-[40px] short:h-[40px] short:!text-sm`;

export const authRootErrorClassName =
	"mb-6 rounded-lg border border-red-200 bg-red-50 p-4 short:mb-2 short:p-2.5";

export const authFormCompactClassName = "auth-form-compact";

export const authLinkRowClassName =
	"auth-link-row !mt-[20px] !mb-[20px] flex flex-wrap items-center justify-between gap-3 text-sm text-gray-700";

export const authOtpFieldLabelClassName =
	"block text-center text-sm font-semibold text-gray-700 short:text-xs";

export const captchaDisplayClassName =
	"flex items-center justify-center px-3 sm:min-h-[3.25rem] short:min-h-[2.5rem] short:px-2 [&_canvas]:block [&_canvas]:max-h-[2.75rem] [&_canvas]:w-auto short:[&_canvas]:max-h-[2.25rem]";

export const captchaDisplayStyle = {
	borderRadius: captchaDisplayRadius,
	border: `${captchaDisplayBorderWidth}px solid ${captchaDisplayBorder}`,
	background: captchaDisplayBackground,
} as const;

export const captchaRefreshButtonClassName =
	"inline-flex w-auto max-w-full shrink-0 items-center justify-center gap-1 rounded-lg border-[1.2px] border-[#D9D9D9] bg-white px-3 text-base font-medium text-gray-800 shadow-sm transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 sm:min-h-[3.25rem] short:min-h-[2.5rem] short:px-2 short:text-sm";

export const authCaptchaLabelClassName =
	"mb-2 block text-sm font-semibold text-gray-900 short:mb-1 short:text-xs";

export const authCaptchaInputWrapClassName = "mt-2 short:mt-1";
